import { useCallback, useEffect, useState } from "react";
import { clockingApi } from "@/network/network.jsx";
import type { ClockingSettings } from "../types";

export function useClockingSettings(
  boardId: number | string | null | undefined,
  enabled: boolean
) {
  const [settings, setSettings] = useState<ClockingSettings | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (boardId == null || !enabled) {
      setSettings(null);
      return;
    }
    setIsLoading(true);
    try {
      const { data } = await clockingApi(boardId).getSettings();
      setSettings(data as ClockingSettings);
    } catch {
      setSettings(null);
    } finally {
      setIsLoading(false);
    }
  }, [boardId, enabled]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { settings, isLoading, refresh };
}
